import { render, staticRenderFns } from "./ManualOrderUsageFeeDetails.vue?vue&type=template&id=5adffae0&scoped=true"
import script from "./ManualOrderUsageFeeDetails.vue?vue&type=script&lang=js"
export * from "./ManualOrderUsageFeeDetails.vue?vue&type=script&lang=js"
import style0 from "./ManualOrderUsageFeeDetails.vue?vue&type=style&index=0&id=5adffae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adffae0",
  null
  
)

export default component.exports